import { render } from "./DayValue.vue?vue&type=template&id=4f24716e&scoped=true"
import script from "./DayValue.vue?vue&type=script&lang=js"
export * from "./DayValue.vue?vue&type=script&lang=js"

import "./DayValue.vue?vue&type=style&index=0&id=4f24716e&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f24716e"]])

export default __exports__